import { BrandItem, SortedBrands } from '../CategoryBrandPage';
import { categoryList_categoryList_children } from '../../../queries/__generated__/categoryList';

export function cleanBrands(brands: categoryList_categoryList_children[]): BrandItem[] {
    const brandCategories = brands.map((brand) => {
        return {
            url_path: brand.url_path || 'unknown',
            name: brand.name || 'unknown',
        };
    });
    return brandCategories;
}

export function sortBrands(brands: BrandItem[]): SortedBrands[] {
    return Object.values(
        brands.reduce((a, brand) => {
            const firstLetter = brand.name[0];
            if (!a[firstLetter]) {
                a[firstLetter] = {
                    title: firstLetter,
                    children: [brand],
                };
            } else {
                a[firstLetter].children.push(brand);
            }
            return a;
        }, {}),
    );
}
